import { useRef, useCallback, useEffect } from 'react';
import styles from './FJImageExtenderPreviewCanvas.module.less';
import PropTypes from 'prop-types';
import FJUtil from '../../../../util/FJUtil';

const FJImageExtenderPreviewCanvas = props => {
    const { imageRect, boardRect, previewSize, uploadImageInfo } = props;

    const isLoadedRef = useRef(false);

    const previewCanvasRef = useRef(null);
    const boardCanvasRef = useRef(null);

    const imgRef = useRef(null);

    useEffect(() => {
        isLoadedRef.current = false;
    }, [uploadImageInfo.src]);

    useEffect(() => {
        const boardCanvas = boardCanvasRef.current;
        const boardCtx = boardCanvas.getContext('2d');

        if (boardRect.width > 0 && boardRect.height > 0) {
            FJUtil.drawTransparentBackground(boardCtx, boardRect.width, boardRect.height);
        }
    }, [boardRect]);

    const drawPreview = useCallback(() => {
        const canvas = previewCanvasRef.current;
        // 移动端模糊，放大清晰度
        const magnification = 3;
        canvas.width = previewSize.width * magnification;
        canvas.height = previewSize.height * magnification;
        const ctx = canvas.getContext('2d');

        if (isLoadedRef.current) {
            const img = imgRef.current;
            ctx.drawImage(
                img,
                imageRect.x * magnification,
                imageRect.y * magnification,
                imageRect.width * magnification,
                imageRect.height * magnification,
            );
        }
    }, [imageRect, isLoadedRef, previewSize]);

    useEffect(() => {
        drawPreview();
    }, [drawPreview]);

    const onLoad = () => {
        isLoadedRef.current = true;
        drawPreview();
    };

    return (
        <>
            <canvas
                ref={boardCanvasRef}
                className={styles.board_canvas}
                width={boardRect.width}
                height={boardRect.height}
                style={{ height: boardRect.height, width: boardRect.width, left: boardRect.x, top: boardRect.y }}
            ></canvas>

            <canvas
                ref={previewCanvasRef}
                className={styles.preview_canvas}
                width={previewSize.width}
                height={previewSize.height}
            ></canvas>
            <img ref={imgRef} src={uploadImageInfo.src} alt='' className={styles.preview_img} onLoad={onLoad} />
        </>
    );
};

FJImageExtenderPreviewCanvas.propTypes = {
    uploadImageInfo: PropTypes.object,
    imageRect: PropTypes.object,
    boardRect: PropTypes.object,
    previewSize: PropTypes.object,
};

export default FJImageExtenderPreviewCanvas;
